import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import RichText from "@/components/RichText";
import type { ResolvedPromoContent } from "../types";
import { buildBackground } from "./promoHelpers";
import { CtaButton } from "./CtaButton";
import { PromoCountdown } from "../countdown/PromoCountdown";
interface ShowcaseVariantProps {
  promo: ResolvedPromoContent;
  textColor: string;
  ctaBackground: string;
  ctaTextColor: string;
  href: string | null;
  isExternal: boolean;
  /** Stretch to the parent height (cells of a promo row) */
  fillHeight?: boolean;
}
export const ShowcaseVariant: React.FC<ShowcaseVariantProps> = t0 => {
  const $ = _c(47);
  const {
    promo,
    textColor,
    ctaBackground,
    ctaTextColor,
    href,
    isExternal,
    fillHeight: t1
  } = t0;
  const fillHeight = t1 === undefined ? false : t1;
  const t2 = `relative w-full overflow-hidden rounded-lg py-8 lg:py-12${fillHeight ? " h-full" : ""}`;
  let t3;
  if ($[0] !== textColor) {
    t3 = {
      color: textColor
    };
    $[0] = textColor;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== promo) {
    t4 = promo.overlayImageUrl ? <img src={promo.overlayImageUrl} alt="" className="h-full w-full object-cover" /> : <div className="h-full w-full" style={{
      background: buildBackground(promo, "banner")
    }} />;
    $[2] = promo;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 bg-black/30" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <div className="absolute inset-0">{t4}{t5}</div>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(24px)",
      WebkitBackdropFilter: "blur(24px)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.35)"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== promo.logoUrl || $[9] !== promo.name) {
    t8 = promo.logoUrl && <div className="relative mb-4 md:mb-6 h-16 w-16 md:h-20 md:w-20"><Image src={promo.logoUrl} alt={promo.name ?? ""} fill={true} className="object-contain" unoptimized={true} /></div>;
    $[8] = promo.logoUrl;
    $[9] = promo.name;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== promo.headline) {
    t9 = promo.headline && <h2 className="text-xl md:text-2xl lg:text-3xl font-bold leading-tight text-balance mb-4">{promo.headline}</h2>;
    $[11] = promo.headline;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== promo.description) {
    t10 = promo.description && <RichText content={promo.description} className="text-sm md:text-base opacity-80 mb-4 lg:mb-6" />;
    $[13] = promo.description;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== ctaBackground || $[16] !== ctaTextColor || $[17] !== promo.countdown || $[18] !== textColor) {
    t11 = promo.countdown && <div className="mb-4 lg:mb-6"><PromoCountdown countdown={promo.countdown} textColor={textColor} ctaBackground={ctaBackground} ctaTextColor={ctaTextColor} interactive={true} align="center" /></div>;
    $[15] = ctaBackground;
    $[16] = ctaTextColor;
    $[17] = promo.countdown;
    $[18] = textColor;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== ctaBackground || $[21] !== ctaTextColor || $[22] !== href || $[23] !== isExternal || $[24] !== promo.ctaText) {
    t12 = href && <CtaButton href={href} isExternal={isExternal} text={promo.ctaText ?? "Learn More"} backgroundColor={ctaBackground} textColor={ctaTextColor} rounded={true} />;
    $[20] = ctaBackground;
    $[21] = ctaTextColor;
    $[22] = href;
    $[23] = isExternal;
    $[24] = promo.ctaText;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== promo.disclaimer) {
    t13 = promo.disclaimer && <p className="text-xs opacity-60 mt-3">{promo.disclaimer}</p>;
    $[26] = promo.disclaimer;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t8 || $[33] !== t9) {
    t14 = <div className="w-full lg:w-1/2 flex justify-center lg:justify-start"><div className="flex flex-col items-center justify-center rounded-2xl p-6 lg:p-8 text-center max-w-md w-full" style={t7}>{t8}{t9}{t10}{t11}{t12}{t13}</div></div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t8;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== promo.headline || $[36] !== promo.name || $[37] !== promo.showcaseImageUrl) {
    t15 = promo.showcaseImageUrl && <div className="w-full lg:w-1/2 flex justify-center"><img src={promo.showcaseImageUrl} alt={promo.headline ?? promo.name ?? ""} className="block max-w-lg object-contain object-center" /></div>;
    $[35] = promo.headline;
    $[36] = promo.name;
    $[37] = promo.showcaseImageUrl;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t14 || $[40] !== t15) {
    t16 = <div className="relative z-10 flex flex-col items-center gap-6 px-4 lg:flex-row lg:gap-8 lg:px-12">{t14}{t15}</div>;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t16 || $[43] !== t2 || $[44] !== t3 || $[45] !== t6) {
    t17 = <section className={t2} style={t3}>{t6}{t16}</section>;
    $[42] = t16;
    $[43] = t2;
    $[44] = t3;
    $[45] = t6;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
};